<script lang="ts">
  import { createEventDispatcher, onMount } from "svelte";
  import { DossierService } from "../../services/dossier.service";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import SearchDropdown from "../Form/Fields/Dropdown/SearchDropdown.svelte";

  export let placeholder: string = "";
  export let required: boolean = false;
  export let disabled: boolean = false;
  export let clearVisible: boolean = false;
  export let filterVisible: boolean = false;
  export let name: string = "";
  export let value: number = null;
  export let small: boolean = false;

  const dispatch = createEventDispatcher();

  let items: IDropdownItem[] = [];

  function onFilter(event: CustomEvent) {
    let filter: string = event.detail;
    search(filter);
  }

  async function search(_filter: string) {
    let rangeRes = await DossierService.getDossierYearsRange();
    let range = rangeRes.payload;
    let vals = new Array<IDropdownItem>();
    for (let i = range.maxYear; i >= range.minYear; i--) {
      vals.push(<IDropdownItem>{ oid: i, label: `${i}` });
    }
    items = vals;
  }

  function onSelect(event: CustomEvent) {
    if (event == null) {
      dispatch("clear");
    } else {
      dispatch("select", event.detail);
    }
  }

  onMount(() => search(""));
</script>

<SearchDropdown
  {placeholder}
  {required}
  {disabled}
  {clearVisible}
  {filterVisible}
  {name}
  {items}
  {small}
  bind:value
  on:filter={onFilter}
  on:select={onSelect}
/>
